import { render, staticRenderFns } from "./ChooseDecisorsPage.vue?vue&type=template&id=b5cc4bec&scoped=true&"
import script from "./ChooseDecisorsPage.vue?vue&type=script&lang=ts&"
export * from "./ChooseDecisorsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseDecisorsPage.vue?vue&type=style&index=0&id=b5cc4bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cc4bec",
  null
  
)

export default component.exports